import PlanFragment from './PlanFragment';
export default `
  query FindPlan($filter: ListPlansTableFilterInput) {
    findPlan(filter: $filter) {
      ...PlanFragment
    }
  }
  ${PlanFragment}
`;
